export const urlDynamic = {
    path: {
        homeFa: "/",
        login: "/login",
        profile: "/profile",
        signup: "/signup",
        forgetPassword: "/forgot-password",
        error500: '/مشکلی-در-ارتباط-با-سرور-رخ-داده-است',
        // gozareshe tasviri agar adresash avaz she hame chi be ham mirzie
        gozareshTasviriFa: '/گزارش-تصویری',
        search: 'جستجو',
        newsAllFa: '/آرشیو-اخبار',
        niroyeEnsani: '/نیروی-انسانی',
        newsAllMarjaiatFa: '/آرشیو-اخبار-مرجعیت-علمی',
        kotobMarjaitElmiFa: '/کتب-مرجعیت-علمی',
        mahsoolatJadid: '/محصولات-جدید',
        hekmatBonyan: '/دانشنامه-نصر-در-حوزه-دانشگاه-حکمت-بنیان',
        karAfarin: '/نوآور-و-کارآفرین',
        pezeshkKhanevade: '/پزشک-خانواده',
        heyatElmi: '/هیات-علمی',
        eghtesadModiriat: '/اقتصاد-و-مدیریت',
        salamat: '/آموزش-عالی-سلامت',
        bimarestan: '/مدیریت-بیمارستانی',
        rotbeBandi: '/رتبه-بندی',
        nokhbegan: '/مهاجرت-نخبگان',
        corona: '/کرونا',
        sazVaKar: '/ساز-و-کار',
        sarFasl: '/سرفصل',
        noavar: '/دانشگاه-نوآور-و-کارآفرین',
        mahsoolatSiasati: '/محصولات-سیاستی',
        amoozeshSalamat: '/آموزش-سلامت',
    },
}
